var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 154 154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    filter: "url(#filter0_i_5524_7482)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1ADCE2",
    d: "m133.024 87.079-66.147 66.147L.731 87.079l10.514-10.514c13.016 5.635 28.26 3.457 38.387-6.731 10.077-10.139 12.23-25.336 6.677-38.333l10.569-10.569 11.095 11.096c13.3-10.153 31.312-10.102 42.247.833 10.935 10.935 11.041 29.002.96 42.373l11.844 11.845Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.4,
    d: "m133.024 87.079-66.147 66.147L.731 87.079l10.514-10.514c13.016 5.635 28.26 3.457 38.387-6.731 10.077-10.139 12.23-25.336 6.677-38.333l10.569-10.569 11.095 11.096c13.3-10.153 31.312-10.102 42.247.833 10.935 10.935 11.041 29.002.96 42.373l11.844 11.845Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_5524_7482)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1ECDD3",
    d: "M55.722 121.386c.172 0 .345-.178.517-.534.173-.356.259-.94.259-1.754V100.79c0-.813-.086-1.385-.259-1.716-.172-.356-.345-.547-.517-.572h11.607c2.168 0 3.992.216 5.47.648 1.48.433 2.662 1.03 3.55 1.793.91.763 1.6 1.64 2.07 2.632.467.966.775 1.996.923 3.089.173 1.093.259 2.199.259 3.318 0 1.017-.086 2.073-.259 3.166a9.968 9.968 0 0 1-.96 3.089c-.469.967-1.159 1.844-2.07 2.632-.888.763-2.07 1.373-3.55 1.831-1.453.458-3.265.686-5.433.686H55.722Zm7.947-4.233h1.516c2.119 0 3.82-.178 5.1-.534 1.282-.382 2.219-1.068 2.81-2.06.592-.991.887-2.428.887-4.31v-.686c0-1.984-.27-3.446-.813-4.386-.542-.967-1.454-1.602-2.735-1.907-1.282-.306-3.031-.458-5.25-.458H63.67c-.714 0-1.146.051-1.294.152-.123.077-.184.382-.184.916v12.129c0 .559.061.889.184.991.148.102.58.153 1.294.153Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_5524_7482",
    width: 134.293,
    height: 136.293,
    x: 0.731,
    y: 20.933,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5524_7482"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_5524_7482",
    width: 24.879,
    height: 23.885,
    x: 55.722,
    y: 98.502,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_5524_7482"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDInactive);
export default __webpack_public_path__ + "static/media/d_inactive.66be906a1b4a5cafa604143c1b6c4993.svg";
export { ForwardRef as ReactComponent };